import ScreenBarPartner from "./components/screen-bar-partner";
import Fireworks from "@fireworks-js/react";
import ScreenDonSection from "./components/screen-don-section";
import {useEffect} from "react";

// CSS autonome du screen "classic-gala".
// IMPORTANT : ce screen ne doit PAS dépendre d'un CSS externe de screen.
// En mode "tokens" (config.tokens présent), RouterPage ne charge QUE campagne.css
// et jamais le CSS du screen → l'écran apparaissait totalement vide.
// On embarque donc ici toutes les règles nécessaires, scopées sous .screen-gala-root.
const GALA_CSS = `
@font-face {
    font-family: "Proxima Nova";
    src: url("/campagne/fonts/proximanova-regular.woff2");
    font-weight: normal;
    font-style: normal
}

.screen-gala-root.screen,
.screen-gala-root .screen { position: relative; }

.screen-gala-root * {
    font-family: Proxima Nova !important;
    font-weight: normal !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.screen-gala-root .screen-background{
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #000;
}

.screen-gala-root .screen-content{
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7%;
}

.screen-gala-root .screen-count-text{
    color:#FFF;
    font-size:15vh;
    text-align:center;
    text-transform:uppercase;
    letter-spacing:3px;
    text-shadow: rgba(0, 0, 0, 0.325) 0px 4.97711px 21.1527px;
}

.screen-gala-root .screen-count-text2{
    color:#FFF;
    font-size:11vh;
    text-align:center;
    text-transform:uppercase;
    letter-spacing:3px;
    text-shadow: rgba(0, 0, 0, 0.325) 0px 4.97711px 21.1527px;
}

.screen-gala-root .screen-progress-bar{
    border-radius: 50px;
    border:5px solid #d4ac73
}

.screen-gala-root .screen-don-card{
    border:10px solid #d4ac73;
    background:radial-gradient(circle at 50% 50%, rgb(105, 2, 40) 0%, rgb(139, 29, 72) 100%) 0px 0px / 508.433px 256px;
    height: 15vh;
    min-width: 20vw;
    max-width: 20vw;
    animation-duration: 1s;
    animation-fill-mode: both;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap:10px;
    overflow-x: hidden;
}

@keyframes screenDonFadeInGala {
    from { left:3vw; opacity: 0; }
    to   { left:0vw; opacity: 1; }
}

.screen-gala-root .screenDonFadeIn {
    animation-name: screenDonFadeInGala;
}

.screen-gala-root .screenDonFadeOut {
    display:none
}
`;


export default function ScreenGala({context,loading, campagneData})
{

    const screenOptions=campagneData?.screenOptions || {}
    const org=context.org

    useEffect(() => {
        document.body.style.overflow="hidden";
        document.body.style.cursor="none";
    }, []);


    if(loading)
    {
        return (
            <div className="screen-gala-root screen" style={{aspectRatio: "16/9", position: "relative"}}>
                <style dangerouslySetInnerHTML={{__html: GALA_CSS}}/>
                <div className={"screen-background"}>
                </div>
            </div>
        )
    }


    return (
        <div className="screen-gala-root screen" style={{aspectRatio: "16/9", position: "relative"}}>
            <style dangerouslySetInnerHTML={{__html: GALA_CSS}}/>
            <div className={"screen-background"}>
                <video src={"/campagne/videos/lubecki-bg.m4v"} autoPlay muted loop
                       style={{height: "100vh", width: "100vw"}}/>

                <div style={{position: "absolute", top: "2vh", right: "1vw"}}>
                    <img src={"/campagne/images/bh.png"} style={{height: "3vh"}}/>
                </div>
            </div>

            <div className={"screen-content"}>
                <div style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                }}>
                    <div>
                        <img src={org.logo} style={{height: "10vh", marginTop: "1vh"}}/>
                    </div>

                    <div style={{marginTop: "5vh",width:"100%"}}>
                        <ScreenBarPartner context={context} campagneData={campagneData} mini={screenOptions.barMini}/>
                    </div>


                    <div style={{marginTop: "5vh",width:"100%"}}>
                        <ScreenDonSection context={context} campagneData={campagneData}/>
                    </div>


                    {screenOptions.forceCelebration &&(
                        <Fireworks
                            autostart
                            options={{intensity:30,particles:100,traceLength:1,opacity:0.2}}
                            style={{
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                position: 'fixed',
                                background: 'transparent'
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
